<template>
  <div>
    <TitlePage
      v-if="!isListingDetails && $route.name !== 'AdminListingDetail'"
      :categoryId="
        listingDetailsFront.listing_category.listing_category_parent.id
      "
    />

    <div class="listing-detail-div row">
      <div class="left-div col-12 col-lg-9">
        <h1 class="listing-detail-title">
          {{ listingDetailsFront ? listingDetailsFront.title : "" }}
        </h1>
        <div class="listing-detail-adress-row">
          <div class="detail-location">
            <MapMarkerIcon />
            {{ listingDetailsFront ? listingDetailsFront.province.name : "" }}
            >
            {{ listingDetailsFront ? listingDetailsFront.district.name : "" }}
          </div>
          <div class="d-none d-md-block">
            <span
              >{{ $t("listingDetail.posted") }} :
              {{
                listingDetailsFront
                  ? formatDate(listingDetailsFront.created_at)
                  : ""
              }}</span
            >
            <span class="margin-left-50"
              >{{ $t("listingDetail.lastUpdate") }} :
              {{
                listingDetailsFront
                  ? formatDate(listingDetailsFront.updated_at)
                  : ""
              }}</span
            >
          </div>
        </div>
        <slider
          :showFavButton="true"
          :imageObjs="sliderImageObject"
          :imageWidth="'100%'"
          imageHeight="380px"
          :disableAction="disableAction"
          :positionIndex="true"
          :isFavorite="isFavorite"
          :listingID="listingDetailsFront.id"
          :price="listingDetailsFront.price"
          @createFavourites="createFavourites"
          @deleteFavourites="deleteFavourites"
          :agency_profile_image="listingDetailsFront.agency_profile_image"
        />

        <div class="description-first-div row no-gutters">
          <div class="listing-id-div col-11 col-md-6">
            <h4 style="font-size: 20px">
              {{ $t("listingDetail.productDetails") }}
            </h4>
            <span
              >(ID :
              {{ listingDetailsFront ? listingDetailsFront.id : "" }})</span
            >
          </div>
          <div
            class="icon-div col-1 col-md-6"
            v-bind:class="{ disabled: disableAction }"
          >
            <h5 class="d-none d-md-block">
              {{ $t("listingDetail.shareProduct") }} :
            </h5>
            <ShareNetwork
              class="d-none d-md-block share"
              network="twitter"
              :url="isListingDetails ? urlShare : '#'"
              :title="listingDetailsFront.title.substring(0, 10)"
              :hashtags="isListingDetails ? listingDetailsFront.keywords : null"
            >
              <TwitterIcon />
            </ShareNetwork>
            <div
              variant="light"
              class="d-none d-md-block share"
              :class="isListingDetails ? null : 'no-pointer'"
              @click="shareToFb(urlShare)"
            >
              <FacebookIcon />
            </div>
            <ShareNetwork
              class="d-none d-md-block share"
              network="line"
              :url="isListingDetails ? urlShare : '#'"
              :title="listingDetailsFront.title.substring(0, 10)"
              :description="description.substring(0, 400)"
            >
              <IconLine class="icon-div-line" />
            </ShareNetwork>
            <ShareNetwork
              class="d-none d-md-block share"
              network="email"
              :url="isListingDetails ? urlShare : '#'"
              :title="listingDetailsFront.title.substring(0, 10)"
              :description="description.substring(0, 400)"
            >
              <IconMailBulk class="d-none d-md-block icon-div-mail share" />
            </ShareNetwork>
            <b-button
              class="report-button"
              size="xs"
              variant="transparent"
              v-b-modal.modal-center
              v-b-tooltip.hover
              :title="$t('listingDetail.report.title')"
              v-if="!isMobile"
            >
              <IconReport />
            </b-button>
            <b-button
              class="report-button"
              size="xs"
              variant="transparent"
              v-b-modal.modal-center
              v-else
            >
              <IconReport />
            </b-button>
            <b-modal
              id="modal-center"
              centered
              hide-header
              hide-footer
              body-class="report-dialog"
            >
              <h4>{{ $t("listingDetail.report.title") }}</h4>
              <div class="report-dialog-div">
                <b-form-radio-group
                  class="report-radio"
                  v-model="reportListing.report_type_id"
                  name="radio-sub-component"
                >
                  <b-form-radio
                    :value="reportType.id"
                    v-for="reportType in reportTypes"
                    v-bind:key="reportType.id"
                    v-model="reportListing.report_type_id"
                    >{{ $t(reportType.name) }}</b-form-radio
                  >
                  <b-form-radio
                    value="0"
                    v-model="reportListing.report_type_id"
                    >{{ $t("listingDetail.report.typeOther") }}</b-form-radio
                  >
                </b-form-radio-group>
                <b-form-textarea
                  class="mt-3"
                  v-if="reportListing.report_type_id == 0"
                  :placeholder="$t('listingDetail.report.inputTypeOrther')"
                  v-bind:class="{
                    'is-required': checkValiReport && !reportListing.comment,
                  }"
                  v-model="reportListing.comment"
                ></b-form-textarea>
                <div class="submit-div">
                  <b-button
                    class="btn-submit-info"
                    :class="reportLoading ? 'disabled' : null"
                    @click="createReport"
                    id="sendReport"
                    style="
                      background-color: var(--projectPrimaryColor);
                      border-color: var(--projectPrimaryColor);
                    "
                  >
                    <b-spinner
                      class="reportSpinner"
                      v-if="reportLoading"
                      small
                      label="Spinning"
                    ></b-spinner>
                    {{
                      reportLoading ? "" : $t("listingDetail.report.send")
                    }}</b-button
                  >
                </div>
              </div>
            </b-modal>
          </div>
        </div>
        <div class="description-second-div">
          <template
            v-for="attributes in listingDetailsFront.listing_attributes_details"
          >
            <div
              class="type-div"
              :class="{
                'type-div-short':
                  listingDetailsFront.listing_attributes_details.length < 3,
              }"
              v-if="attributes.attr_id != 4"
              v-bind:key="attributes.id"
            >
              <div class="type-box">
                <span
                  class="d-inline-block"
                  v-if="
                    attributes.listing_attribute &&
                    attributes.listing_attribute.icon
                  "
                  v-html="attributes.listing_attribute.icon"
                ></span>
                <span class="d-md-inline-block mr-1"
                  >{{ $t(attributes.listing_attribute.name) }}:&nbsp;</span
                >
                <span
                  v-if="attributes.value"
                  v-b-tooltip.hover
                  :title="$t(attributes.value)"
                  variant="primary"
                  >&nbsp;{{ $t(attributes.value) | truncate(15, "...") }}
                </span>
                <span
                  v-if="attributes.pre_values_id"
                  variant="primary"
                  v-b-tooltip.hover
                  :title="$t(attributes.listing_pre_value.value)"
                  >&nbsp;{{
                    $t(attributes.listing_pre_value.value) | truncate(15, "...")
                  }}
                </span>
              </div>
            </div>
          </template>
        </div>

        <div class="description-third-div">
          {{ listingDetailsFront ? description : "" }}
        </div>
        <a
          class="external-website-link"
          :href="listingDetailsFront.website"
          target="_new"
          v-if="
            checkPackageItem(
              'website-url-listing-box',
              listingDetailsFront.listing_premiums
            )
          "
        >
          <IconLink style="width: 20px" />
          {{ listingDetailsFront.website }}</a
        >

        <b-row v-if="isMobile" class="my-5">
          <b-col>
            <b-button
              class="mobile-button"
              v-if="!isFavorite"
              @click="createFavourites()"
              style="width: 100%"
            >
              <IconFavoriteBorder v-b-tooltip.hover :title="$t('Favorites')" />
              {{ $t("favorite") }}
            </b-button>
            <b-button
              class="mobile-button"
              v-else
              @click="deleteFavourites()"
              style="width: 100%"
            >
              <FavoriteIcon v-b-tooltip.hover :title="$t('Unfavorite')" />
              {{ $t("unfavorite") }}
            </b-button>
          </b-col>
          <b-col cols="auto"
            ><b-button
              style="width: 100%"
              class="mobile-button"
              v-b-modal.modal-center
              ><IconReport />{{ $t("Report") }}</b-button
            ></b-col
          >
          <b-col
            ><b-button
              class="mobile-button"
              @click="mobile_contact.share = !mobile_contact.share"
              style="width: 100%"
              ><IconShare />{{ $t("Share") }}</b-button
            ></b-col
          >
        </b-row>

        <div
          class="agency-details mobile-contact"
          v-if="listingDetailsFront.user.agency"
          style="padding: 0"
        >
          <div class="d-flex flex-column mobile-contact-seller">
            <h4>{{ $t("agency.details") }}</h4>
            <div class="d-flex flex-row">
              <div class="col-3">{{ $t("agency.name") }}:</div>
              <div class="col-9">
                {{ listingDetailsFront.user.agency.name  }}
              </div>
            </div>
            <div class="d-flex flex-row">
              <div class="col-3">{{ $t("agency.email") }}:</div>
              <div class="col-9">
                <a
                  :href="
                    listingDetailsFront.user.agency
                      ? 'mailto:' +
                        listingDetailsFront.user.agency.email +
                        '?subject =' +
                        listingDetailsFront.title
                      : 'javascript:void(0)'
                  "
                  >{{ listingDetailsFront.user.agency.email }}</a
                >
              </div>
            </div>
            <div class="d-flex flex-row">
              <div class="col-3">{{ $t("agency.phoneNumber") }}:</div>
              <div class="col-9">
                <a
                  :href="
                    listingDetailsFront.user.agency
                      ? 'tel:' + listingDetailsFront.user.agency.phone_number
                      : 'javascript:void(0)'
                  "
                  >{{ listingDetailsFront.user.agency.phone_number }}</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="isMobile"
        style="min-width: 300px; width: 100%; min-height: 100px; margin: 40px 0"
      >
        <Adsense
          v-if="adsUnderDescription.advertisment_location.google_on"
          data-ad-test="false"
          in-style="display:inline-block;width:300px;height:100px"
          :data-ad-client="$root.googleClientId"
          :data-ad-slot="
            adsUnderDescription.advertisment_location.google_ad_key
          "
          data-full-width-responsive="false"
          data-ad-format="horizontal"
        >
        </Adsense>
      </div>
      <div
        class="floating-div col-3 d-none d-lg-block"
        v-bind:class="{ disabled: disableAction }"
      >
        <div class="contact-box">
          <router-link
            id="sellerDetail"
            :event="isListingDetails ? 'click' : ''"
            class="sellar-div"
            :class="isListingDetails ? null : 'no-pointer'"
            :to="
              $i18nRoute({ name: 'seller-detail' }, listingDetailsFront.user_id)
            "
          >
            <b-img
              :src="
                listingDetailsFront.user &&
                listingDetailsFront.user.profile_image
                  ? listingDetailsFront.user.profile_image
                  : '/images/sellar.png'
              "
              :alt="
                listingDetailsFront.user.display_name
                  ? listingDetailsFront.user.display_name
                  : $t('altTag', {
                      affiliate: $root.affiliate,
                    })
              "
            />
            <div class="name-div">
              <h5>
                {{
                  listingDetailsFront && listingDetailsFront.user
                    ? listingDetailsFront.user.display_name
                    : ""
                }}
              </h5>
              <span>{{ $t("listingDetail.seeAllSellersProducts") }} ></span>
            </div>
          </router-link>
          <div class="price-div">
            <h5 v-if="!salaryType && minSalary">
              {{ minSalary }}
              {{ $t("baht") }}
              -
              {{
                listingDetailsFront
                  ? listingDetailsFront.price.toLocaleString("th-TH")
                  : ""
              }}
              {{ $t("baht") }}
            </h5>
            <!--job category-->
            <h2 v-if="!salaryType && !minSalary">
              {{
                listingDetailsFront
                  ? listingDetailsFront.price.toLocaleString("th-TH")
                  : ""
              }}
            </h2>
            <h5 v-if="!salaryType && !minSalary">{{ $t("baht") }}</h5>
            <h2 v-if="salaryType">{{ salaryType }}</h2>
          </div>
          <div class="line-div" v-if="listingDetailsFront.line_id">
            <div class="line">
              <h4>{{ $t("line") }}</h4>
              <a
                :href="
                  'http://line.me/ti/p/' + listingDetailsFront.line_id
                "
                target="_blank"
              >
                {{ listingDetailsFront.line_id }}
              </a>
            </div>
          </div>
          <div class="phone-div" v-if="phoneNumber">
            <div class="phone">
              <h4>{{ phoneNumber }}</h4>
              <span
                @click="showPhoneNumber"
                v-if="phoneNumber && isListingDetails"
                >{{ $t("listingDetail.clickToSeeTelephoneNumber") }}</span
              >
              <span v-if="!phoneNumber">{{
                $t("listingDetail.noPhoneNumber")
              }}</span>
            </div>
            <div class="phone-while">
              <a
                v-if="listingDetailsFront"
                :event="isListingDetails ? 'click' : ''"
                :class="isListingDetails ? null : 'no-pointer'"
                :href="
                  listingDetailsFront &&
                  listingDetailsFront.phone &&
                  isListingDetails
                    ? `tel:${listingDetailsFront.phone}`
                    : 'javacript:void(0)'
                "
              >
                <PhoneIcon />
              </a>
            </div>
          </div>

          <div v-if="isListingDetails" class="message-div">
            <b-textarea
              v-model="message.from_message"
              v-bind:class="{
                'is-required': checkValiMessage && !message.from_message,
              }"
            ></b-textarea>
            <div
              class="quick-message"
              v-if="
                listingDetailsFront.listing_category.listing_category_parent
                  .id !== 4
              "
            >
              <span
                @click="
                  message.from_message +=
                    $t('listingDetail.messages.isProductAvailable') + '\n'
                "
                >{{ $t("listingDetail.messages.isProductAvailable") }}</span
              >
              <span
                @click="
                  message.from_message +=
                    $t('listingDetail.messages.payInInstallments') + '\n'
                "
                >{{ $t("listingDetail.messages.payInInstallments") }}</span
              >
              <span
                @click="
                  message.from_message +=
                    $t('listingDetail.messages.whereCanISeeProducts') + '\n'
                "
                >{{ $t("listingDetail.messages.whereCanISeeProducts") }}</span
              >
            </div>
            <div>
              <b-button
                @click="createMessage()"
                class="send-button"
                :disabled="disableAction || sendingMessage"
              >
                <b-spinner
                  variant="light"
                  label="Spinning"
                  v-if="disableAction || sendingMessage"
                ></b-spinner>
                <template v-else>{{
                  $t("listingDetail.messages.sendMessage")
                }}</template>
              </b-button>
              <b-modal id="dialog-enter-info" centered hide-footer>
                <div class="title-modal">
                  {{ $t("listingDetail.messages.modal.title") }}
                </div>
                <b-form id="form-info">
                  <b-form-group id="input-group-name" label-for="input-name">
                    <b-form-input
                      :placeholder="$t('listingDetail.messages.modal.name')"
                      class="input-name"
                      v-bind:class="{
                        'is-required': checkValiMessage && !message.from_name,
                      }"
                      v-model="message.from_name"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group id="input-group-phone" label-for="input-phone">
                    <b-form-input
                      :placeholder="$t('listingDetail.messages.modal.phone')"
                      class="input-phone"
                      v-bind:class="{
                        'is-required':
                          checkValiMessage &&
                          !message.from_telephone &&
                          !message.from_email,
                      }"
                      v-model="$v.message.from_telephone.$model"
                      :state="validateState('from_telephone')"
                      aria-describedby="input-from-telephone-live-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      id="input-from-telephone-live-feedback"
                    >
                      <template v-if="message.from_telephone">{{
                        $t("listingDetail.messages.validateMsg.phone")
                      }}</template>
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <div class="or">
                    {{ $t("listingDetail.messages.modal.or") }}
                  </div>
                  <b-form-group id="input-group-email" label-for="input-email">
                    <b-form-input
                      type="email"
                      :placeholder="$t('listingDetail.messages.modal.email')"
                      class="input-email"
                      v-bind:class="{
                        'is-required':
                          checkValiMessage &&
                          !message.from_telephone &&
                          !message.from_email,
                      }"
                      v-model="$v.message.from_email.$model"
                      :state="validateState('from_email')"
                      aria-describedby="input-from-email-live-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      id="input-from-email-live-feedback"
                      >{{
                        $t("listingDetail.messages.validateMsg.email")
                      }}</b-form-invalid-feedback
                    >
                  </b-form-group>
                  <b-button
                    class="btn-submit-info"
                    :disabled="sendingMessage"
                    @click="createMessage"
                    id="sendMessageReport"
                    style="
                      background-color: var(--projectPrimaryColor);
                      border-color: var(--projectPrimaryColor);
                    "
                  >
                    <b-spinner
                      variant="primary"
                      label="Spinning"
                      v-if="sendingMessage"
                    ></b-spinner>
                    <template v-else>{{
                      $t("listingDetail.messages.modal.send")
                    }}</template>
                  </b-button>
                </b-form>
              </b-modal>
            </div>
          </div>
        </div>
        <div
          v-if="!isMobile && verticalAds && $route !== 'AdminListingDetail'"
          class="show-content-under"
        >
          <a
            id="imageRightListingDetail"
            :href="verticalAds.website"
            target="_new"
            v-if="!verticalAds.advertisment_location.google_on"
            @click="CLICK_BANNERADS(verticalAds.id)"
          >
            <b-img :src="verticalAds.image" :alt="verticalAds.website" />
          </a>
          <Adsense
            data-ad-test="false"
            v-else
            in-style="display:block"
            :data-ad-client="$root.googleClientId"
            :data-ad-slot="verticalAds.advertisment_location.google_ad_key"
            data-ad-format="vertical"
            data-full-width-responsive="true"
          >
          </Adsense>
        </div>
      </div>
    </div>
    <b-row class="d-flex d-md-none">
      <b-col cols="12" class="mobile-contact">
        <div class="mobile-contact-seller">
          <div class="seller-img">
            <b-img
              :src="
                listingDetailsFront.user &&
                listingDetailsFront.user.profile_image
                  ? listingDetailsFront.user.profile_image
                  : '/images/sellar.png'
              "
              :alt="
                listingDetailsFront.user.display_name
                  ? listingDetailsFront.user.display_name
                  : $t('altTag', {
                      affiliate: $root.affiliate,
                    })
              "
            />
          </div>
          <div class="seller-detail">
            <p>
              {{
                listingDetailsFront.user && listingDetailsFront.user.name
                  ? listingDetailsFront.user.name
                  : ""
              }}
            </p>
            <p>
              {{ $t("listingDetail.posted") }} :
              {{
                listingDetailsFront
                  ? formatDate(listingDetailsFront.created_at)
                  : ""
              }}
            </p>
            <p>
              {{ $t("listingDetail.lastUpdate") }} :
              {{
                listingDetailsFront
                  ? formatDate(listingDetailsFront.updated_at)
                  : ""
              }}
            </p>
            <p v-if="listingDetailsFront.line_id">
              {{ $t("line") }} :
              <a
                :href="'http://line.me/ti/p/' + listingDetailsFront.line_id"
                target="_blank"
              >
                {{ listingDetailsFront.line_id }}
              </a>
            </p>
            <router-link
              id="sellerDetail"
              :to="
                $i18nRoute(
                  { name: 'seller-detail' },
                  listingDetailsFront.user_id
                )
              "
            >
              <span>{{ $t("listingDetail.seeAllSellersProducts") }}</span>
              <IconArrowRight />
            </router-link>
          </div>
        </div>
      </b-col>
    </b-row>

    <div
      class="mobile-contact-seller-fixed d-block d-md-none"
      v-if="
        $route.name === 'AdminListingDetail' || $route.name === 'ListingDetail'
      "
    >
      <div class="mobile-button-div">
        <b-row no-gutters style="width: 100%">
          <b-col
            :cols="listingDetailsFront.phone ? 4 : 6"
            v-if="listingDetailsFront.line_id"
          >
            <div
              class="box-seller box-share"
              style="border-right: 2px solid white"
            >
              <a @click="showLineDialog = !showLineDialog">
                <img src="/images/line-icon.png" />
              </a>
              <b-modal
                id="modal-mobile-seller-mail"
                centered
                hide-footer
                :title="$t('Line')"
                v-model="showLineDialog"
              >
                <b-row align-content="center" align-h="center" align-v="center">
                  <b-col cols="12">
                    <p style="width: 100%; text-align: center">
                      Line: {{ listingDetailsFront.line_id }}
                    </p>
                  </b-col>
                  <b-col cols="12">
                    <a
                      :href="
                        'http://line.me/ti/p/~' + listingDetailsFront.line_id
                      "
                      target="_blank"
                      style="
                        background: var(--projectPrimaryColor);
                        padding: 8px;
                        width: 100%;
                        text-align: center;
                        display: block;
                        border-radius: ;
                      "
                    >
                      {{ $t("Go to Line") }}
                    </a>
                  </b-col>
                </b-row>
              </b-modal>
            </div>
          </b-col>
          <b-col
            :cols="listingDetailsFront.line_id ? 4 : 6"
            v-if="listingDetailsFront && listingDetailsFront.phone"
          >
            <div class="box-seller" style="border-right: 2px solid white">
              <a @click="showCallModel = !showCallModel">
                <IconPhone /> {{ $t("Call") }}
              </a>
              <b-modal
                id="modal-mobile-seller-mail"
                centered
                hide-footer
                :title="$t('Phone')"
                v-model="showCallModel"
              >
                <b-row align-content="center" align-h="center" align-v="center">
                  <b-col cols="12">
                    <p style="width: 100%; text-align: center">
                      {{ $t("Phone Number") }}: {{ listingDetailsFront.phone }}
                    </p>
                  </b-col>
                  <b-col cols="12">
                    <a
                      :href="
                        listingDetailsFront && listingDetailsFront.phone
                          ? 'tel:' + listingDetailsFront.phone
                          : 'javascript:void(0)'
                      "
                      style="
                        background: var(--projectPrimaryColor);
                        padding: 8px;
                        width: 100%;
                        text-align: center;
                        display: block;
                        border-radius: ;
                      "
                    >
                      {{ $t("Call") }}
                    </a>
                  </b-col>
                </b-row>
              </b-modal>
            </div>
          </b-col>
          <b-col
            :cols="
              listingDetailsFront.line_id
                ? 4
                : listingDetailsFront.phone
                ? 6
                : 12
            "
          >
            <div
              class="box-seller box-mail"
              @click="showDialogMobile"
              style="padding-top: 7px"
            >
              <img src="/images/chat-icon.png" /> {{ $t("Chat") }}
            </div>
            <b-modal
              id="modal-mobile-seller-mail"
              centered
              hide-footer
              :title="$t('listingDetail.messages.titleMessage')"
              v-model="mobile_contact.mail"
            >
              <b-container fluid>
                <b-row class="mb-1 text-center">
                  <b-form-textarea
                    id="reasons-input"
                    v-model="message.from_message"
                    :placeholder="`${$t(
                      'listingDetail.messages.isProductAvailable'
                    )}...`"
                    v-bind:class="{
                      'is-required': checkValiMessage && !message.from_message,
                    }"
                    rows="4"
                    no-resize
                  ></b-form-textarea>
                  <div class="wrapper">
                    <b-button
                      class="btn-pls-check"
                      id="isProductAvailable"
                      @click="
                        message.from_message +=
                          $t('listingDetail.messages.isProductAvailable') + '\n'
                      "
                      >{{
                        $t("listingDetail.messages.isProductAvailable")
                      }}</b-button
                    >
                    <b-button
                      class="btn-pls-check"
                      id="payInInstallments"
                      @click="
                        message.from_message +=
                          $t('listingDetail.messages.payInInstallments') + '\n'
                      "
                      >{{
                        $t("listingDetail.messages.payInInstallments")
                      }}</b-button
                    >
                    <b-button
                      class="btn-pls-check"
                      id="whereCanISeeProducts"
                      @click="
                        message.from_message +=
                          $t('listingDetail.messages.whereCanISeeProducts') +
                          '\n'
                      "
                      >{{
                        $t("listingDetail.messages.whereCanISeeProducts")
                      }}</b-button
                    >
                  </div>
                  <div class="wrap-btn-send">
                    <b-button
                      class="btn-send success-button"
                      id="sendMessage"
                      @click="showDialog"
                      :disabled="sendingMessage"
                      >{{ $t("listingDetail.messages.sendMessage") }}</b-button
                    >
                  </div>
                </b-row>
              </b-container>
            </b-modal>
          </b-col>
        </b-row>
      </div>
      <!-- <b-row>
        <b-col cols="12">
          <b-button
            class="seller-btn success-button"
            :href="listingDetailsFront.website"
            v-if="listingDetailsFront.website"
            >{{ $t("listingDetail.sellerBtnMobile") }}</b-button
          >
        </b-col>
      </b-row> -->
    </div>
    <b-modal
      :hide-header="true"
      :hide-footer="true"
      :centered="true"
      v-model="mobile_contact.share"
      id="modal-share"
    >
      <ShareNetwork
        network="twitter"
        :url="isListingDetails ? urlShare : '#'"
        :title="listingDetailsFront.title.substring(0, 10)"
        :hashtags="listingDetailsFront.keywords"
      >
        <TwitterIcon />
      </ShareNetwork>
      <div
        variant="light"
        class="d-md-block share"
        :class="isListingDetails ? null : 'no-pointer'"
        @click="shareToFb(urlShare)"
      >
        <FacebookIcon />
      </div>
      <ShareNetwork
        network="line"
        :url="isListingDetails ? urlShare : '#'"
        :title="listingDetailsFront.title.substring(0, 10)"
        :description="description.substring(0, 400)"
      >
        <IconLine class="icon-line" />
      </ShareNetwork>
      <ShareNetwork
        network="Email"
        :url="isListingDetails ? urlShare : '#'"
        :title="listingDetailsFront.title.substring(0, 10)"
        :description="description.substring(0, 400)"
      >
        <IconMailBulk class="icon-mail" />
      </ShareNetwork>
    </b-modal>
    <b-modal
      id="login-message-dialog"
      centered
      hide-footer
      v-model="showLoginMessageDialog"
      style="width: 500px"
    >
      <b-container fluid>
        <b-row class="mb-1 text-center">
          <p>{{ $t("listingDetail.messages.loginMessage") }}</p>
          <b-row
            class="wrap-btn-send justify-content-center w-100"
            align-content="center"
            no-gutters
          >
            <b-button
              class="btn-send success-button"
              id="sendMessage"
              @click="openLogin"
              style="margin-right: 10px"
              ><IconLogin style="margin-right: 10px" />{{
                $t("login")
              }}</b-button
            >
            <b-button
              class="btn-send success-button"
              id="signUp"
              @click="openLogin"
              style="margin-left: 10px"
            >
              <IconUserPlus />
              {{ $t("signup") }}
            </b-button>
          </b-row>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import getEnv from "@/utils/env";
import * as actionType from "@/controllers/ActionTypes";
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import moment from "moment";
import $ from "jquery";
import { validationMixin } from "vuelidate";
import {
  required,
  numeric,
  integer,
  maxLength,
  email,
} from "vuelidate/lib/validators";

import TitlePage from "@/components/ui/titlePage";
import Slider from "@/components/imageSliderListingDetail/index";

// Icons
import PhoneIcon from "vue-material-design-icons/Phone.vue";
import MapMarkerIcon from "vue-material-design-icons/MapMarker.vue";
import IconReport from "@/components/icons/IconReport/index";
import IconLink from "@/components/icons/IconLink";
import TwitterIcon from "vue-material-design-icons/Twitter.vue";
import FacebookIcon from "vue-material-design-icons/Facebook.vue";
import IconLine from "@/components/icons/IconLine";
import IconMailBulk from "@/components/icons/IconMailBulk";
import IconArrowRight from "@/components/icons/IconArrowRight/index";
import IconShare from "@/components/icons/IconShare/index";
import IconPhone from "@/components/icons/IconPhone/index";
import IconMail from "@/components/icons/IconMail/index";
import IconLogin from "@/components/icons/IconLogin/index";
import IconUserPlus from "@/components/icons/IconUserPlus/index";
import { Trans } from "@/plugins/Translation";
import IconFavoriteBorder from "vue-material-design-icons/HeartOutline.vue";
import FavoriteIcon from "vue-material-design-icons/Heart.vue";

export default {
  mixins: [validationMixin],
  components: {
    TitlePage,
    Slider,
    PhoneIcon,
    MapMarkerIcon,
    IconReport,
    IconLink,
    TwitterIcon,
    FacebookIcon,
    IconLine,
    IconMailBulk,
    IconArrowRight,
    IconShare,
    IconPhone,
    // IconMail,
    IconLogin,
    IconUserPlus,
    IconFavoriteBorder,
    FavoriteIcon,
  },
  props: {
    listingDetailsFront: {
      type: Object,
      default: () => {
        return {};
      },
    },
    verticalAds: {
      type: Object,
      default: () => {
        return {
          image: "",
          website: "#",
          advertisment_location: {
            google_on: true,
            google_ad_key: null,
          },
        };
      },
    },
    adsUnderDescription: {
      type: Object,
      default: () => {
        return {
          image: "",
          website: "#",
          advertisment_location: {
            google_on: true,
            google_ad_key: null,
          },
        };
      },
    },
    hideFooter: Boolean,
  },
  data() {
    return {
      showLoginMessageDialog: false,
      isAdmin:
        localStorage.getItem("user_profile") &&
        JSON.parse(localStorage.getItem("user_profile")).admin_type.name ==
          "Admin"
          ? true
          : false,
      sendingMessage: false,
      disableAction: this.$route.name === "ListingDetail" ? false : true,
      isListingDetails: this.$route.name === "ListingDetail" ? true : false,
      minSalary: 0,
      salaryType: null,
      reportLoading: false,
      mobile_contact: {
        share: false,
        phone: false,
        mail: false,
      },
      isFavorite: this.listingDetailsFront.fav === "0" ? false : true,
      urlShare: null,
      reportListing: {
        listing_id: Number(this.$route.params.id),
        report_type_id: 1,
        comment: "",
      },
      message: {
        user_id: 0,
        listing_id: Number(this.$route.params.id),
        from_user_id: 0,
        from_name: "",
        from_telephone: "",
        from_email: "",
        from_message: "",
      },
      phoneNumber: "",
      description: "",
      userLogin: null,
      checkValiMessage: false,
      checkValiReport: false,
      showLineDialog: false,
      showCallModel: false,
      sliderImageObject: [
        {
          imageUrl: "/images/Image1.png",
          boldText: "",
          description: "",
          link: "#",
        },
        {
          imageUrl: "/images/Image2.png",
          boldText: "",
          description: "",
          link: "#",
        },
        {
          imageUrl: "/images/Image3.png",
          boldText: "",
          description: "",
          link: "#",
        },
      ],
    };
  },
  validations: {
    message: {
      from_telephone: {
        required,
        numeric,
        integer,
        maxLength: maxLength(10),
      },
      from_email: {
        email,
      },
    },
  },

  created() {
    if (
      this.$router.currentRoute.path !=
        this.$i18nRoute({ name: "add-listing" }) &&
      this.$router.currentRoute.path !=
        this.$i18nRoute({ name: "user-manage" }) &&
      this.$router.currentRoute.name != "EditListing"
    ) {
      this.GET_REPORT_TYPE({
        take: 10,
        page: 1,
      });
    }

    this.urlShare = `${getEnv("VUE_APP_API_URL")}/listings/${
      this.$route.params.id
    }/share?site_url=${window.location.origin}`;
  },

  mounted() {
    this.getListingDetails();
    document.documentElement.style.setProperty(
      "--seukhaiMainDarkColor",
      this.shadeColor(this.$root.primary_color, 30)
    );
    document.documentElement.style.setProperty(
      "--seukhaiMainMoreDarkColor",
      this.shadeColor(this.$root.primary_color, 20)
    );
    document.documentElement.style.setProperty(
      "--seukhaiMainMoreMoreDarkColor",
      this.shadeColor(this.$root.primary_color, 5)
    );
    document
      .querySelector(":root")
      .style.setProperty(
        "--seukhaiMainDarkColor",
        this.shadeColor(this.$root.primary_color, 30)
      );
    document
      .querySelector(":root")
      .style.setProperty(
        "--seukhaiMainMoreDarkColor",
        this.shadeColor(this.$root.primary_color, 20)
      );
    document
      .querySelector(":root")
      .style.setProperty(
        "--seukhaiMainMoreMoreDarkColor",
        this.shadeColor(this.$root.primary_color, 5)
      );
  },

  computed: {
    ...mapGetters("UserController", ["isMobile"]),
    ...mapState("ListingDetailController", [
      "reportTypes",
      "listingSellerDetail",
    ]),
    ...mapGetters("CategoryController", ["textSearch"]),
  },

  watch: {
    listingDetailsFront(val) {
      this.getListingDetails();
    },
    $route(to, from) {
      this.urlShare = `${getEnv("VUE_APP_API_URL")}/listings/${
        this.$route.params.id
      }/share?site_url=${window.location.origin}`;
      this.message = {
        user_id: 0,
        listing_id: Number(this.$route.params.id),
        from_user_id: 0,
        from_name: "",
        from_telephone: "",
        from_email: "",
        from_message: "",
      };
      this.$nextTick(() => {
        this.$v.message.$reset();
      });
    },
  },

  methods: {
    ...mapActions("ChatController", ["SEND_CHAT_MESSAGE"]),
    ...mapActions("AdsController", ["CLICK_BANNERADS"]),
    ...mapActions("UserController", ["isTablet"]),
    ...mapActions("FavouriteController", [
      "CREATE_FAVOURITES_USER",
      "DELETE_FAVOURITES_USER",
    ]),
    ...mapActions("ListingDetailController", [
      "GET_LISTING_INTERESTINGS",
      "GET_REPORT_TYPE",
      "GET_LISTING_DETAILS_FOR_FRONT",
      "CREATE_REPORT_LISTING_DETAIL",
      "CREATE_MESSAGE_LISTING_DETAIL",
    ]),
    shadeColor(color, percent) {
      var R = parseInt(color.substring(1, 3), 16);
      var G = parseInt(color.substring(3, 5), 16);
      var B = parseInt(color.substring(5, 7), 16);

      R = parseInt((R * (100 - percent)) / 100);
      G = parseInt((G * (100 - percent)) / 100);
      B = parseInt((B * (100 - percent)) / 100);

      R = R < 255 ? R : 255;
      G = G < 255 ? G : 255;
      B = B < 255 ? B : 255;

      var RR =
        R.toString(16).length == 1 ? "0" + R.toString(16) : R.toString(16);
      var GG =
        G.toString(16).length == 1 ? "0" + G.toString(16) : G.toString(16);
      var BB =
        B.toString(16).length == 1 ? "0" + B.toString(16) : B.toString(16);

      return "#" + RR + GG + BB;
    },
    checkPackageWebsite(type, user_payments) {
      let existFeature = user_payments.find((item) => {
        if (item.status !== 3) {
          return false;
        }
        const existPackage = item.user_payments_details.find((temp) => {
          if (temp.packages_detail.package_id === 6) {
            return true;
          }
          return false;
        });
        return !!existPackage;
      });
      return !!existFeature;
    },

    shareToFb(url) {
      if (!this.isListingDetails) {
        return;
      }
      FB.init({
        appId: 374448816898457,
        status: true,
        cookie: true,
        xfbml: true,
        version: "v2.10",
      });
      FB.ui(
        {
          method: "share",
          href: url,
          hashtag: this.listingDetailsFront.keywords
            ? this.listingDetailsFront.keywords
            : "",
        },
        (response) => {
          if (response) {
          } else {
          }
        },
        (err) => {}
      );
    },

    async createReport() {
      this.reportLoading = true;
      if (!this.$root.isAuthenticated) {
        this.reportLoading = false;
        return this.$bvToast.toast(
          this.$t("listingDetail.report.msgNotLogin.content"),
          {
            title: this.$t("listingDetail.report.msgNotLogin.title"),
            variant: "warning",
            solid: true,
          }
        );
      }
      let user = JSON.parse(localStorage.getItem("user_profile"));
      if (user.id == this.listingDetailsFront.user_id) {
        this.reportLoading = false;
        return this.$bvToast.toast(
          this.$t("listingDetail.report.msgSelfReport.content"),
          {
            title: this.$t("listingDetail.report.msgSelfReport.title"),
            variant: "warning",
            solid: true,
          }
        );
      }

      let request = Object.assign({}, this.reportListing);

      if (request.report_type_id == 0) {
        this.checkValiReport = true;
        if (!request.comment) {
          this.reportLoading = false;
          return;
        }
      } else {
        request.comment = this.reportTypes[request.report_type_id - 1].name;
      }

      await this.CREATE_REPORT_LISTING_DETAIL(request)
        .then((response) => {
          this.$bvModal.hide("modal-center");
          if (response) {
            this.reportListing.report_type_id = 1;
            this.reportListing.comment = "";
            this.reportLoading = false;
            return this.$bvToast.toast(
              this.$t("listingDetail.report.msgCreateSuccess.content"),
              {
                title: this.$t("listingDetail.report.msgCreateSuccess.title"),
                variant: "success",
                solid: true,
              }
            );
          }
        })
        .catch((err) => {
          this.reportLoading = false;
          return this.$bvToast.toast(
            this.$t("listingDetail.report.noResponse.content"),
            {
              title: this.$t("listingDetail.report.noResponse.title"),
              variant: "warning",
              solid: true,
            }
          );
        });
    },
    async createMessage() {
      this.checkValiMessage = true;

      if (this.$root.isAuthenticated && !this.message.from_message) return;

      if (!this.$root.isAuthenticated) {
        this.showLoginMessageDialog = true;
        // this.openLogin();
        this.$v.message.$touch();
        if (this.$v.message.$anyError) return;
        if (
          (!this.message.from_message || !this.message.from_name) &&
          !this.message.from_telephone &&
          !this.message.from_email
        )
          return;
      }
      this.sendingMessage = true;
      this.checkValiMessage = false;
      var formData = new FormData();
      formData.append("type", "LISTING");
      formData.append("listing_id", Number(this.$route.params.id));
      // formData.append('chat_id', null);
      formData.append("message", this.message.from_message);
      await this.SEND_CHAT_MESSAGE({ formData: formData, admin: this.isAdmin })
        .then(async (data) => {
          await this.$bvModal.hide("dialog-enter-info");
          this.message = {
            user_id: 0,
            listing_id: Number(this.$route.params.id),
            from_user_id: 0,
            from_name: "",
            from_telephone: "",
            from_email: "",
            from_message: "",
          };
          this.$nextTick(() => {
            this.$v.message.$reset();
          });
          this.sendingMessage = false;
          return this.$bvToast.toast(
            this.$t("listingDetail.messages.msgCreateSuccess.content"),
            {
              title: "",
              variant: "success",
              solid: true,
            }
          );
        })
        .catch((err) => {
          this.sendingMessage = false;
          if (err.data.detail == "CHAT_NOT_ALLOWED") {
            this.message.from_message = null;
            this.$bvToast.toast(
              this.$t("userDashboard.messages.youAreBlocked"),
              {
                title: ``,
                variant: "dangor",
                solid: true,
              }
            );
          }
        });

      // this.message.user_id = this.listingDetailsFront.user_id;
      // await this.SEND_CHAT_MESSAGE(this.message)
      // 	.then(async (response) => {
      // 		await this.$bvModal.hide('dialog-enter-info');
      // 		if (response) {
      // 			this.message = {
      // 				user_id: 0,
      // 				listing_id: Number(this.$route.params.id),
      // 				from_user_id: 0,
      // 				from_name: '',
      // 				from_telephone: '',
      // 				from_email: '',
      // 				from_message: ''
      // 			};
      // 			this.$nextTick(() => {
      // 				this.$v.message.$reset();
      // 			});
      // 			return this.$bvToast.toast(
      // 				this.$t('listingDetail.messages.msgCreateSuccess.content'),
      // 				{
      // 					title: this.$t('listingDetail.messages.msgCreateSuccess.title'),
      // 					variant: 'success',
      // 					solid: true
      // 				}
      // 			);
      // 		}
      // 	})
      // 	.catch((err) => {
      //
      // 		if (err.data.detail == 'CHAT_NOT_ALLOWED') {
      // 			this.chatMessage.blocked = true;
      // 			this.text = null;
      // 			this.mediaList = [];
      // 			this.chatMessage.messages.pop();
      // 			this.$bvToast.toast(
      // 				this.$t('userDashboard.messages.youAreBlocked'),
      // 				{
      // 					title: `Error`,
      // 					variant: 'dangor',
      // 					solid: true
      // 				}
      // 			);
      // 		}
      // 	});
    },
    createFavourites(id) {
      if (this.$root.isAuthenticated) {
        this.isFavorite = true;
        this.CREATE_FAVOURITES_USER({
          listing_id: this.listingDetailsFront.id,
        });
      }
    },
    deleteFavourites(data) {
      if (this.$root.isAuthenticated) {
        this.isFavorite = false;
        this.DELETE_FAVOURITES_USER({
          id: this.listingDetailsFront.id,
        });
      }
    },
    showDialog() {
      if (!this.userLogin) {
        let user = JSON.parse(localStorage.getItem("user_profile"));
        if (user && user.id) {
          this.userLogin = user;
        }
      }
      this.checkValiMessage = true;
      if (!this.message.from_message) return;
      this.checkValiMessage = false;
      if (this.$root.isAuthenticated && this.userLogin) {
        if (this.userLogin.id == this.listingDetailsFront.user_id) {
          return this.$bvToast.toast(
            this.$t("listingDetail.messages.msgWarning.content"),
            {
              title: this.$t("listingDetail.messages.msgWarning.title"),
              variant: "warning",
              solid: true,
            }
          );
        }
        this.message.from_user_id = this.userLogin.id;
        this.createMessage();
        return;
      }
      if (this.isTablet) {
        this.$bvModal.hide("modal-mobile-seller-mail");
      }
      this.$bvModal.show("dialog-enter-info");
    },
    showDialogMobile() {
      this.message.from_message = "";
      this.mobile_contact.mail = !this.mobile_contact.mail;
    },
    favorite() {
      this.isFavorite = !this.isFavorite;
    },
    openLogin() {
      this.$root.signIn();
    },
    replacePhoneNumberXX: function (value) {
      if (!value) return;
      let arr = value.split("");
      arr[arr.length - 1] = "X";
      arr[arr.length - 2] = "X";
      return arr.join("");
    },
    showPhoneNumber() {
      this.phoneNumber =
        this.listingDetailsFront && this.listingDetailsFront.phone
          ? this.listingDetailsFront.phone
          : "";
    },
    async getListingDetails() {
      if (this.listingDetailsFront) {
        this.phoneNumber = this.replacePhoneNumberXX(
          this.listingDetailsFront &&
            this.listingDetailsFront &&
            this.listingDetailsFront.phone
            ? this.listingDetailsFront.phone
            : ""
        );
        this.sliderImageObject = [
          {
            imageUrl: this.listingDetailsFront.url_feature_image,
            boldText: "",
            description: "",
            link: "#",
            altTitle: this.listingDetailsFront.title,
          },
        ];
        if (this.listingDetailsFront.listing_images.length) {
          this.listingDetailsFront.listing_images.forEach((element) => {
            let obj = {
              imageUrl: element.url_image,
              boldText: "",
              description: "",
              link: "#",
              altTitle: this.listingDetailsFront.title,
            };
            this.sliderImageObject.push(obj);
          });
        }

        this.listingDetailsFront.listing_attributes_details.forEach(
          (element) => {
            if (element.attr_id == 15) {
              this.minSalary = element.value ? element.value : 0;
            }
            if (element.attr_id == 18 && element.pre_values_id != 56) {
              this.salaryType = element.listing_pre_value.value
                ? element.listing_pre_value.value
                : null;
            }
          }
        );
      }
      // this.description = this.listingDetailsFront.description.replace(
      // 	/(\d)([() -]*)(\d)([() -]*)(\d)([() -]*)(\d)([() -]*)(\d)([() -]*)(\d)([() -]*)(\d+)/g,
      // 	`Phone number : x\$2x\$4x\$6x\$8x\$10x\$12\$13`
      // );
      this.description = this.listingDetailsFront.description.replace(
        /(?:\b[a-z\d.-]+:\/\/[^<>\s]+|\b(?:(?:(?:[^\s!@#$%^&*()_=+[\]{}\|;:'",.<>/?]+)\.)+(?:ac|ad|aero|ae|af|ag|ai|al|am|an|ao|aq|arpa|ar|asia|as|at|au|aw|ax|az|ba|bb|bd|be|bf|bg|bh|biz|bi|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|cat|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|coop|com|co|cr|cu|cv|cx|cy|cz|de|dj|dk|dm|do|dz|ec|edu|ee|eg|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gb|gd|ge|gf|gg|gh|gi|gl|gm|gn|gov|gp|gq|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|im|info|int|in|io|iq|ir|is|it|je|jm|jobs|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mg|mh|mil|mk|ml|mm|mn|mobi|mo|mp|mq|mr|ms|mt|museum|mu|mv|mw|mx|my|mz|name|na|nc|net|ne|nf|ng|ni|nl|no|np|nr|nu|nz|om|org|pa|pe|pf|pg|ph|pk|pl|pm|pn|pro|pr|ps|pt|pw|py|qa|re|ro|rs|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|sk|sl|sm|sn|so|sr|st|su|sv|sy|sz|tc|td|tel|tf|tg|th|tj|tk|tl|tm|tn|to|tp|travel|tr|tt|tv|tw|tz|ua|ug|uk|um|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|xn--0zwm56d|xn--11b5bs3a9aj6g|xn--80akhbyknj4f|xn--9t4b11yi5a|xn--deba0ad|xn--g6w251d|xn--hgbk6aj7f53bba|xn--hlcj6aya9esc7a|xn--jxalpdlp|xn--kgbechtv|xn--zckzah|ye|yt|yu|za|zm|zw)|(?:(?:[0-9]|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])\.){3}(?:[0-9]|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5]))(?:[;/][^#?<>\s]*)?(?:\?[^#<>\s]*)?(?:#[^<>\s]*)?(?!\w))/gim,
        `<< Website : xxxxxxx >>`
      );

      this.listingDetailsFront.listing_attributes_details.forEach((element) => {
        if (element.attr_id == 15) {
          this.minSalary = element.value ? element.value : 0;
        }
        if (element.attr_id == 18 && element.pre_values_id != 56) {
          this.salaryType = element.listing_pre_value.value
            ? element.listing_pre_value.value
            : null;
        }
      });
    },
    checkPackageItem(type, arr) {
      if (!arr || !arr.length) return false;
      if (type == "feature") {
        return arr.some((item) => item.package_id == 1);
      }

      if (type == "urgent") {
        return arr.some((item) => item.package_id == 3);
      }

      if (type == "negotiable") {
        return arr.some((item) => item.package_id == 4);
      }

      if (type == "highlight") {
        return arr.some((item) => item.package_id == 5);
      }

      if (type == "website-url-listing-box") {
        return arr.some((item) => item.package_id == 6);
      }

      return false;
    },
    formatDate(date) {
      var formatTimezone = moment(date).toDate();
      return moment(formatTimezone)
        .locale(Trans.currentLanguage)
        .format("DD MMM YYYY");
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.message[name];
      return $dirty ? !$error : null;
    },
  },
};
</script>

<style lang="scss" scopped>
@import "listingDetail.scss";
.mobile-button {
  background-color: var(--projectPrimaryColor);
  color: white;
  font-size: 12px !important;
  .feather-alert-triangle,
  .feather-share-2 {
    height: 15px;
    padding-right: 5px;
  }
}
</style>
